export const PRODUCT_API_URL = 'https://api.portal.kassa24.kz/v2';
